import React from 'react';
export const DefaultId = () => (
  <svg width="140px" height="118px" viewBox="0 0 140 118" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-555.000000, -1880.000000)">
        <g transform="translate(556.000000, 1880.000000)">
          <path
            d="M14.6602,1.6938 C14.6602,2.2758 14.1882,2.7478 13.6062,2.7478 C13.0242,2.7478 12.5522,2.2758 12.5522,1.6938 C12.5522,1.1108 13.0242,0.6388 13.6062,0.6388 C14.1882,0.6388 14.6602,1.1108 14.6602,1.6938"
            fill="#F5C400"
          />
          <path
            d="M37.188,113.5395 L18.432,113.5395"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.4317,113.5395 L0.3957,113.5395"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M81.8462,113.2758 C81.8462,115.3608 74.4822,117.0498 65.3972,117.0498 C56.3132,117.0498 48.9492,115.3608 48.9492,113.2758 C48.9492,111.1908 56.3132,109.5008 65.3972,109.5008 C74.4822,109.5008 81.8462,111.1908 81.8462,113.2758"
            fill="#D0D7DA"
          />
          <path
            d="M80.3208,70.9203 L29.5128,77.8013 C27.3768,78.0903 25.4108,76.5943 25.1218,74.4583 L21.0238,44.1993 C20.7348,42.0643 22.2318,40.0983 24.3668,39.8093 L75.1748,32.9283 C77.3108,32.6393 79.2768,34.1353 79.5658,36.2713 L83.6638,66.5293 C83.9528,68.6653 82.4568,70.6313 80.3208,70.9203"
            fill="#FFFFFF"
          />
          <g transform="translate(20.000000, 37.710000)">
            <path
              d="M17.3262,0.3529 L2.9392,2.3019 C1.5922,2.4839 0.6482,3.7239 0.8302,5.0719 L5.3152,38.1849 C5.4972,39.5329 6.7382,40.4759 8.0852,40.2939 L19.2152,38.7869 L24.5272,38.0669 L61.7482,33.0259 C63.0962,32.8429 64.0402,31.6039 63.8572,30.2559 L63.5072,27.6709"
              fill="#FFFFFF"
            />
            <path
              d="M17.3262,0.3529 L2.9392,2.3019 C1.5922,2.4839 0.6482,3.7239 0.8302,5.0719 L5.3152,38.1849 C5.4972,39.5329 6.7382,40.4759 8.0852,40.2939 L19.2152,38.7869 L24.5272,38.0669 L61.7482,33.0259 C63.0962,32.8429 64.0402,31.6039 63.8572,30.2559 L63.5072,27.6709"
              stroke="#C3D3D8"
              strokeWidth="1.001"
              strokeLinecap="round"
            />
          </g>
          <g transform="translate(21.000000, 37.710000)">
            <polyline
              fill="#F3F4F6"
              points="8.6309 13.598 1.1229 14.616 0.3259 8.73 58.8679 0.801 59.6649 6.687 11.8009 13.169"
            />
            <polyline
              stroke="#DDE3E2"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="8.6309 13.598 1.1229 14.616 0.3259 8.73 58.8679 0.801 59.6649 6.687 11.8009 13.169"
            />
          </g>
          <g transform="translate(40.000000, 51.710000)">
            <path d="M0.2027,3.9105 L22.9237,0.8335" fill="#DDE3E2" />
            <path
              d="M0.2027,3.9105 L22.9237,0.8335"
              stroke="#DDE5E8"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(26.000000, 55.710000)">
            <path d="M0.1314,1.8168 L11.4354,0.2858" fill="#DDE3E2" />
            <path
              d="M0.1314,1.8168 L11.4354,0.2858"
              stroke="#DDE5E8"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(40.000000, 54.710000)">
            <path d="M0.1534,3.7064 L23.3124,0.5694" fill="#DDE3E2" />
            <path
              d="M0.1534,3.7064 L23.3124,0.5694"
              stroke="#DDE5E8"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(26.000000, 58.710000)">
            <path d="M0.5205,1.5521 L11.4275,0.0751" fill="#DDE3E2" />
            <path
              d="M0.5205,1.5521 L11.4275,0.0751"
              stroke="#DDE5E8"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M91.8584,65.1215 L43.1884,65.1215 C40.3144,65.1215 37.9844,62.7925 37.9844,59.9185 L37.9844,31.9855 C37.9844,29.1115 40.3144,26.7825 43.1884,26.7825 L91.8584,26.7825 C94.7324,26.7825 97.0614,29.1115 97.0614,31.9855 L97.0614,59.9185 C97.0614,62.7925 94.7324,65.1215 91.8584,65.1215"
            fill="#F3F4F6"
          />
          <path
            d="M95.6206,61.8256 L44.3496,61.8256 C42.1936,61.8256 40.4466,60.0786 40.4466,57.9236 L40.4466,27.3886 C40.4466,25.2336 42.1936,23.4866 44.3496,23.4866 L95.6206,23.4866 C97.7756,23.4866 99.5236,25.2336 99.5236,27.3886 L99.5236,57.9236 C99.5236,60.0786 97.7756,61.8256 95.6206,61.8256"
            fill="#FFFFFF"
          />
          <path
            d="M47.2876,48.0404 L55.4926,48.0404"
            stroke="#D62793"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M59.5952,48.0404 L67.8002,48.0404"
            stroke="#D62793"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M71.9029,48.0404 L80.1079,48.0404"
            stroke="#D62793"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M84.2105,48.0404 L92.4155,48.0404"
            stroke="#D62793"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M47.2876,52.9633 L54.2616,52.9633"
            stroke="#C3D3D8"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M55.0982,43.5199 L48.0922,43.5199 C47.6482,43.5199 47.2872,43.1599 47.2872,42.7149 L47.2872,35.7089 C47.2872,35.2649 47.6482,34.9049 48.0922,34.9049 L55.0982,34.9049 C55.5422,34.9049 55.9032,35.2649 55.9032,35.7089 L55.9032,42.7149 C55.9032,43.1599 55.5422,43.5199 55.0982,43.5199"
            fill="#FEFCDD"
          />
          <path
            d="M55.0982,43.5199 L48.0922,43.5199 C47.6482,43.5199 47.2872,43.1599 47.2872,42.7149 L47.2872,35.7089 C47.2872,35.2649 47.6482,34.9049 48.0922,34.9049 L55.0982,34.9049 C55.5422,34.9049 55.9032,35.2649 55.9032,35.7089 L55.9032,42.7149 C55.9032,43.1599 55.5422,43.5199 55.0982,43.5199 Z"
            stroke="#F5C400"
            strokeWidth="0.751"
            strokeLinecap="round"
          />
          <path
            d="M47.2876,39.2123 L55.9026,39.2123"
            stroke="#F5C400"
            strokeWidth="0.751"
            strokeLinecap="round"
          />
          <polygon
            fill="#FFFFFF"
            points="50.6675 41.3754 49.5865 40.2954 49.5865 38.1304 50.6675 37.0504 52.5235 37.0504 53.6045 38.1304 53.6045 40.2954 52.5235 41.3754"
          />
          <path
            d="M52.6792,36.6733 L50.5112,36.6733 C50.0032,37.1823 49.7192,37.4663 49.2102,37.9753 L49.2102,40.4493 C49.7192,40.9573 50.0032,41.2423 50.5112,41.7503 L52.6792,41.7503 L53.9802,40.4493 L53.9802,37.9753 C53.4722,37.4663 53.1872,37.1823 52.6792,36.6733 M52.3682,37.4243 L53.2292,38.2853 L53.2292,40.1393 L52.3682,40.9993 L50.8232,40.9993 L50.2142,40.3913 L49.9612,40.1393 L49.9612,38.2853 L50.3922,37.8553 L50.8232,37.4243 L52.3682,37.4243"
            fill="#F5C400"
          />
          <path
            d="M55.8941,23.4867 L95.6211,23.4867 C97.7761,23.4867 99.5231,25.2337 99.5231,27.3887 L99.5231,57.9237 C99.5231,60.0787 97.7761,61.8257 95.6211,61.8257 L44.3491,61.8257 C42.1941,61.8257 40.4471,60.0787 40.4471,57.9237 L40.4471,27.3887 C40.4471,25.2337 42.1941,23.4867 44.3491,23.4867 L49.2071,23.4867"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M137.5987,113.7367 L92.8087,113.7367"
            stroke="#EB1D26"
            strokeWidth="1.001"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="88.8863 58.5795 96.5893 58.5795 96.5893 54.5715"
          />
          <path
            d="M83.4576,58.5795 L86.3136,58.5795"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
